import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import SpinnerDot from "../../components/SpinnerDot";
import useAxiosJwtQuery from "../../hooks/useAxiosJwtQuery";
import DeleteConfirmationModal from "../../modals/DeleteConfirmationModal";

export default function ManageProducts() {
  const [modalId, setModalId] = useState(null);

  const [parts, refetch] = useAxiosJwtQuery(`/parts`);

  return (
    <div class="w-auto">
      <div class="hero-content flex flex-col">
        {modalId && (
          <DeleteConfirmationModal
            id={modalId}
            toast={toast}
            refetch={refetch}
          />
        )}

        <ToastContainer />

        <h1 class="text-center text-5xl font-bold">Manage Products</h1>

        <div class="card flex-shrink-0 w-full">
          {!parts ? (
            <SpinnerDot />
          ) : !(parts?.length > 0) ? (
            <h1 class="text-center text-5xl text-[teal] font-bold">
              No Products Found!
            </h1>
          ) : (
            <div class="overflow-x-auto text-center">
              <table class="table w-fit mx-auto">
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Quantity</th>
                    <th className="text-center">Price Per Unit</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {parts.map(({ _id, name, quantity, price }, i) => (
                    <tr key={_id}>
                      <th>{i + 1}</th>
                      <td>{name}</td>
                      <td className="text-center">{quantity}</td>
                      <td className="font-bold text-center">{price}</td>
                      <td>
                        <label
                          onClick={() => {
                            setModalId(_id);
                          }}
                          for={_id}
                          className="modal-button btn border-0 bg-red-600 hover:bg-red-700"
                        >
                          Delete Product
                        </label>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
